import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiFilter } from 'react-icons/fi';
import { fetchAPI } from '../../utils/api';

export default function StudentCourses() {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(true);

    React.useEffect(() => {
        const loadTeachers = async () => {
            try {
                const data = await fetchAPI('/student/get_teachers.php');
                // Note: Adding a default color if not present in DB
                const coloredData = data.map((t, i) => ({
                    ...t,
                    color: t.color || (i % 3 === 0 ? 'from-blue-500 to-blue-600' : i % 3 === 1 ? 'from-red-500 to-red-600' : 'from-purple-500 to-purple-600')
                }));
                setTeachers(coloredData);
            } catch (err) {
                console.error("Failed to load teachers", err);
            } finally {
                setLoading(false);
            }
        };
        loadTeachers();
    }, []);

    if (loading) return <div className="p-8 text-center text-gray-500 font-bold">Loading teachers...</div>;

    return (
        <div className="flex flex-col lg:flex-row gap-6 h-[calc(100vh-8rem)]">
            {/* Sidebar Filters */}
            {/* Sidebar Search - Hidden on Mobile */}
            <div className="hidden lg:block w-full lg:w-80 bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex-shrink-0 lg:h-full overflow-y-auto font-display">
                <h3 className="font-bold text-gray-700 mb-4">Search teacher</h3>
                <div className="relative mb-8">
                    <input
                        type="text"
                        placeholder="Type name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-4 pr-10 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all font-medium text-sm"
                    />
                    <button className="absolute right-0 top-0 bottom-0 px-4 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700 transition-colors">
                        <FiSearch />
                    </button>
                </div>

                <h3 className="font-bold text-gray-700 mb-4">Filters</h3>
                <div className="space-y-4">
                    <div className="relative">
                        <select className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 appearance-none focus:outline-none focus:border-blue-500">
                            <option>By grade</option>
                            <option>Grade 12</option>
                            <option>Grade 13</option>
                        </select>
                        <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                            <FiFilter size={14} />
                        </div>
                    </div>
                    <div className="relative">
                        <select className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 appearance-none focus:outline-none focus:border-blue-500">
                            <option>By subject</option>
                            <option>Mathematics</option>
                            <option>Science</option>
                        </select>
                        <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                            <FiFilter size={14} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="flex-1 overflow-y-auto">
                {/* bg-gradient-to-r from-blue-300 via-white-500 to-blue-900 */}
                <div className="w-full h-48 rounded-xl mb-8 flex items-center justify-center relative overflow-hidden bg-[url('https://t4.ftcdn.net/jpg/04/37/93/59/360_F_437935932_eJsRZ3d11tpE5g7gW7DfVboXdkSAorLI.jpg')]">
                    {/* Abstract Banner Design */}
                    <div className="absolute inset-0 bg-[url('https://www.freepik.com/free-photo/liquid-marbling-paint-texture-background-fluid-painting-abstract-texture-intensive-color-mix-wallpaper_26543298.htm#fromView=search&page=1&position=4&uuid=d6b7656d-1790-4c97-ab60-0f508298f9ab&query=backgrod')] opacity-10"></div>
                    <div className="z-10 text-center">
                        <h1 className="text-3xl font-bold text-white font-display mb-2">Maths with Manoj</h1>
                        <p className="text-white font-medium tracking-wide">A IS OUR GOAL</p>
                        <p className="text-white text-xs mt-2">www.mathswithmanoj.com</p>
                    </div>
                </div>

                {/* Teacher Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {teachers.map((teacher) => (
                        <div
                            key={teacher.id}
                            onClick={() => navigate(`/dashboard/courses/teacher/${teacher.id}`)}
                            className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden group hover:shadow-md transition-all duration-300 cursor-pointer"
                        >
                            <div className={`h-32 bg-gradient-to-br ${teacher.color} opacity-10 relative`}></div>
                            <div className="px-6 -mt-12 text-center pb-6">
                                <img
                                    src={teacher.image_url || teacher.image}
                                    alt={teacher.name}
                                    className="w-24 h-24 rounded-full border-4 border-white mx-auto shadow-md object-cover bg-gray-100 group-hover:scale-105 transition-transform duration-300"
                                />
                                <h3 className="text-lg font-bold text-gray-900 mt-4">{teacher.name}</h3>
                                <p className="text-gray-500 text-sm font-medium mb-6">{teacher.subject}</p>
                                <button
                                    className="w-full py-2.5 bg-blue-600 text-white font-bold rounded-lg text-sm hover:bg-blue-700 transition-all shadow-lg shadow-blue-200"
                                >
                                    SEE CLASSES
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
